import React from 'react';
import Contacto from '../components/Contacto';

function Contact() {
    return <Contacto />;
}

export default Contact;
